<template>
  <div class="code-join-team-container">
    <div class="code-join-team-box">
      <el-form
        ref="teamJoinForm"
        v-loading="saveLoading"
        :model="teamJoinForm"
        :rules="teamJoinRules"
        :disabled="saveLoading"
        class="code-join-team-form"
        label-width="var(--team-entry-label-width, 120px)"
        @submit.prevent="joinTeam"
      >
        <el-form-item
          :label="$t('views.user_center.invitation_code')"
          prop="inviteCode"
        >
          <el-input
            v-model="teamJoinForm.inviteCode"
            autocomplete="off"
            autocapitalize="none"
            @input="formError = ''"
            :placeholder="$t('views.user_center.enter_invitation_code')"
          />
        </el-form-item>
      </el-form>
      <el-alert v-if="formError" class="team-form-error" :title="formError" type="error" :closable="false" show-icon />
    </div>

  </div>
</template>

<script>
import { getTeamInfoByInviteCode, joinTeam } from '@/api/team'

export default {
  name: 'CodeJoinTeam',
  components: {},
  emits: ['update-team', 'close-dlg', 'busy-change'],
  props: {
    isDialog: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      teamJoinForm: {
        inviteCode: ''
      },
      teamJoinRules: {
        inviteCode: [
          { required: true, message: this.$t('views.user_center.enter_invitation_code'), trigger: 'blur' }
        ]
      },
      saveLoading: false,
      teamInfo: {},
      formError: '',
      requestSerial: 0,
      disposed: false
    }
  },
  computed: {
    businessContext() {
      return `${this.$store.getters.user_id || ''}:${this.$store.getters.current_team_id || ''}`
    }
  },
  watch: {
    saveLoading(value) {
      this.$emit('busy-change', value)
    },
    businessContext() {
      this.requestSerial += 1
      this.saveLoading = false
      this.formError = ''
    }
  },
  mounted() {
  },
  beforeUnmount() {
    this.disposed = true
    this.requestSerial += 1
    this.$emit('busy-change', false)
  },
  methods: {
    async joinTeam() {
      if (this.saveLoading || this.disposed || !this.$refs.teamJoinForm) return
      const serial = ++this.requestSerial
      const context = this.businessContext
      const isCurrent = () => !this.disposed && serial === this.requestSerial && context === this.businessContext
      this.formError = ''
      this.saveLoading = true
      try {
        const valid = await this.$refs.teamJoinForm.validate().catch(() => false)
        if (!valid || !isCurrent()) return
        const params = { invite_code: this.teamJoinForm.inviteCode.trim() }
        const teamResponse = await getTeamInfoByInviteCode(params)
        if (!isCurrent()) return
        if (!teamResponse || ![0, 200].includes(Number(teamResponse.code))) {
          this.formError = this.$t('views.user_center.join_team_failed')
          return
        }
        this.teamInfo = teamResponse.data || {}
        const response = await joinTeam(params)
        if (!isCurrent()) return
        if (!response || ![0, 200].includes(Number(response.code))) {
          this.formError = this.$t('views.user_center.join_team_failed')
          return
        }
        if (this.isDialog) {
          if (Number(response.data && response.data.apply_status) !== 1) {
            this.$message.success(this.$t('views.user_center.join_team_applied'))
            this.$emit('close-dlg')
          } else {
            this.$message.success(this.$t('views.user_center.join_team_success'))
            this.$emit('update-team', response.data && response.data.team_id)
          }
        }
      } catch (error) {
        if (isCurrent()) this.formError = error && error.message ? error.message : this.$t('views.user_center.join_team_failed')
      } finally {
        if (isCurrent()) this.saveLoading = false
      }
    },
    initJoinTeam() {
      this.requestSerial += 1
      this.saveLoading = false
      this.formError = ''
      this.teamJoinForm.inviteCode = ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/views/user_center/components/code_join_team";
@import "@/views/mobile/user_center/styles/team_forms";
</style>
